import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

import {
  Question,
} from "../../types/Question";
import generateSurveyXml from "./survey";

export interface XmlExportState {
  xmlData: string;
  isPreviewOpen: boolean;
}

const initialState: XmlExportState = {
  xmlData: "",
  isPreviewOpen: false,
};

export const xmlExportSlice = createSlice({
  name: "xmlExport",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    showPreview: (state, action: PayloadAction<Question[]>) => {
      state.isPreviewOpen = true;
      state.xmlData = generateSurveyXml(action.payload);
    },
    closePreview: (state) => {
      state.isPreviewOpen = false;
    },
  },
});

export const {
  showPreview,
  closePreview,
} = xmlExportSlice.actions;

export const selectorXmlExport = (state: RootState) =>
  state.xmlExport;

export default xmlExportSlice.reducer;
